// extracted by mini-css-extract-plugin
export default {"logo":"labelLogo_logo__4Ptcg"};